import { render, staticRenderFns } from "./MatchSuspensionReminderEdit.vue?vue&type=template&id=77455c78&scoped=true&"
import script from "./MatchSuspensionReminderEdit.vue?vue&type=script&lang=js&"
export * from "./MatchSuspensionReminderEdit.vue?vue&type=script&lang=js&"
import style0 from "./MatchSuspensionReminderEdit.vue?vue&type=style&index=0&id=77455c78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77455c78",
  null
  
)

export default component.exports